import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import './styles.css';

import Layout from '../../UI/introGameLayout/layout';

import { coursesQuery, tournamentsQuery } from './api';

import ReviewSessionHeader from '../../UI/instructor/onboarding/reviewSession/competitionHeader';
import ReviewSessionFooter from '../../UI/instructor/onboarding/reviewSession/competitionFooter';

import TournamentRound1 from './images/tournament-round-1.jpg';
import TournamentRound2 from './images/tournament-round-2.jpg';
import TournamentRound3 from './images/tournament-round-3.jpg';
import TournamentRound4 from './images/tournament-round-4.jpg';

export default function InstructorOnboardingCompetition() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [roundCount, setRoundCount] = useState(null);
  const [tournamentId, setTournamentId] = useState(null);

  const handleViewMoreDetailsButtonClick = async () => {
    if (!tournamentId) return;
    // Refetch generalInfo before navigating so the tournament-edit
    // page mounts with games[] / sessions[] that include the just-
    // created tournament rounds. Without this, edit-tournament.js
    // sees the stale cached generalInfo (without the new games),
    // formData stays empty, and the page renders with the round
    // editor + Add Level button but no scenario data until a hard
    // reload — same caching issue we fixed for the Classification
    // create-game flow.
    await queryClient.refetchQueries({ queryKey: ['generalInfo'] });
    navigate(`/instructor/settings/tournament/edit/${tournamentId}`);
  }

  const { data: courses } = useQuery(coursesQuery());

  const { data: tournaments } = useQuery(tournamentsQuery('competition'));

  useEffect(() => {
    if(courses?.length > 0 && tournaments?.length > 0) {
      const courseId = courses[0].id;

      const courseTournaments = tournaments.filter(tournament => tournament.course_id === courseId);
      const latestTournament = courseTournaments.reduce((max, tournament) => tournament.id > max.id ? tournament : max, courseTournaments[0]);

      setRoundCount(latestTournament.round_count);
      setTournamentId(latestTournament.id);
    }
  }, [courses, tournaments]);

  const tournamentImages = {
    1: TournamentRound1,
    2: TournamentRound2,
    3: TournamentRound3,
    4: TournamentRound4
  };

  return (
    <Layout
      isHeaderVisible={true}
      isContentVertical={true}
      className="instructor-onboarding-competition-layout"
      backgroundColor="#FFF8EB"
    >
      <ReviewSessionHeader
        title="Review Session Competition at a glance:"
        description="Review the competition structure and details for your course."
      />
      
      <img 
        src={tournamentImages[roundCount] || TournamentRound4} 
        alt={`Tournament round ${roundCount || 4}`} 
        className="tournament-round-image"
      />

      <ReviewSessionFooter
        nextButtonText="View More Details"
        onNext={handleViewMoreDetailsButtonClick}
      />
    </Layout>
  );
}
